import { render, staticRenderFns } from "./OrganKidneys.vue?vue&type=template&id=641d2045&"
var script = {}
import style0 from "./OrganKidneys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports